<template>
        <div>
            <div class="flex items-center justify-center h-screen">
                <div class="sm:block w-1/2 bg-cover h-screen" style='background: url(login-bckg-2.jpg)'>
                    <div class="bg-blue-800 w-full h-screen bg-opacity-20">
                    </div>
                </div>
                <div class="sm:w-1/2">
                  <div class="p-5 w-5/5 mx-auto text-left font-raleway">
                    <div class="text-left mb-10"> 
                        <router-link v-if="user.role.name <= 0" to="/">
                            <font-awesome-icon class="mr-5" :icon="['fas', 'arrow-left']" /> Home
                        </router-link> 
                        <router-link v-else-if="user.role.name > 0" to="/home">
                            <font-awesome-icon class="mr-5" :icon="['fas', 'arrow-left']" /> Dashboard
                        </router-link> 
                    </div>
                    <div v-if="user.role.name > 0">
                      <h1 class="font-bold text-left font-montserrat text-4xl sm:text-6xl mb-10">
                      Willkommen. {{ user.username }}. To. eduBB
                    </h1>
                    <section> 
                      <b-notification
                          type="is-success"
                          has-icon
                          aria-close-label="Close notification">
                          Du hast keine neuen Nachrichten. Enjoy und be happy 
                      </b-notification>
                    </section>
                    </div>
                    <div v-else>
                    <h1 class="font-bold text-left font-montserrat text-4xl sm:text-6xl mb-10">
                      Login. To. eduBB
                    </h1>
                    <p v-show="error" class="text-sm text-red-500">{{ errorMsg }}</p>
                    <form action="#" @submit.prevent="submit">
                      <div class="my-5">
                          <h1 class="text-left font-bold mb-5 font-montserrat">Email</h1>
                          <input
                            id="email"
                            type="email"
                            class="text-sm outline-none pb-5 w-5/5 bg-transparent border-b hover:border-blue-700 focus:border-blue-700"
                            name="email"
                            value
                            required
                            autofocus
                            v-model="form.email"                    
                          />
                        </div>
                        <div class="my-5">
                          <h1 class="text-left font-bold mb-5 font-montserrat">Passwort</h1>
                          <div class="password-input">
                          <input
                            id="password"
                            :type="showPassword ? 'text' : 'password'"
                            class="text-sm outline-none pb-5 w-5/5 bg-transparent border-b hover:border-blue-700 focus:border-blue-700"
                            name="password"
                            value
                            required
                            autofocus
                            v-model="form.password"                    
                          />
                          <!-- <i
                            class="toggle-password-icon fas"
                            :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                            @click="togglePasswordVisibility"
                          ></i> -->
                        </div>
                          <label for="showPassword" class="ml-2">
                            <input
                              id="showPassword"
                              type="checkbox"
                              v-model="showPassword"
                              @click="togglePasswordVisibility"
                            />
                            Passwort anzeigen
                          </label>
                        </div>                                
                        <button type="submit" class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full">Login <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /></button>
                        <p class="my-2">
                        <router-link to="/forgotpassword" >Passwort vergessen?</router-link>
                        </p>
                        <p class="my-3">
                          <button type="submit" class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-4 rounded-full">
                        <router-link to="/register" >Keinen Account? Hier registrieren!</router-link>
                      </button>
                      </p>
                    </form>
                </div>
            </div>
          
          </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

library.add(faEye, faEyeSlash);

export default {
  name: 'LoginPage',
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      showPassword: false,
      user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
      error: null,
      errorMsg: `An error occured, please try again`
    };
  },
/*   mounted(){
    console.log()
    if(this.$route.path.name.includes('/auth/email-confirmation')){
      console.log("Du kommst von der Confirm Webseite")
    }
  }, */
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        setTimeout(() => {
          this.showPassword = false;
        }, 3000);
      }
    },
    async submit(e) {
      e.preventDefault()

      try{     
        const email = this.form.email;
        const password = this.form.password;


        const data = await this.$store.dispatch("authenticateUser", {
          email,
          password,
        });

        console.log("data", data)
        switch (data.user.role.name) {
          case "Student":
            data.user.role.name = 1;
            break;
          case "Instructor":
            data.user.role.name = 2;
            break;
          case "Editor":
            data.user.role.name = 3;
            break;  
            case "Feuerwehr":
            data.user.role.name = 4;
            break;
          default:
            break;
        }

        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("token", data.token);
        console.log("redirect", this.$store.state.pastPath)
        //this.$router.go(this.$route.query.redirect || '/')
        // THis will redirect to the page you were on before you logged in
        if(this.$store.state.pastPath){
          this.$router.push(this.$store.state.pastPath)
        }
        // this will update the current page and reload it to provide logout button
        this.$router.go("/");
    
      }catch (error){
        this.error = true
        this.password= ''
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
</style>
